/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Executive } from 'Types/PersonTypes';
import {
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import HeadingWithShowAll from 'Components/globalSearch/components/HeadingWithShowAll';
import SectionHeading from 'Components/globalSearch/components/SectionHeading';
import { Tooltip } from 'antd';
import {
  backgroundColorParsing, formatNumberWithCommas, getCurrentTime, isOnboardingRoute, valueToObject,
} from 'Utils/UtilityFunctions';
import {
  selectIsPagination,
  selectPersonLoaded,
  selectSearchLoaded,
} from 'Selector/GlobalSearchResultsSelector';
import classNames from 'classnames';

import { UpdatePersonProfileFollow } from 'Types/RequestBodies';
import { actions as peopleFollowActions } from 'Slice/PeopleFollowSlice';
import { actions as flurryActions } from 'Slice/HelperSlice';
import {
  FEED_GILROY_ROUTE, PERSONALITY_INSIGHTS_ROUTE, SEARCH, SEARCH_ROUTE,
} from 'Utils/Constants';
import { selectFollowFailed, selectFollowLoading } from 'Selector/PeopleFollowSelector';
import { actions as certificationActions } from 'Slice/CertificationSlice';
import { selectData } from 'Selector/CertificationSelector';
import DrawerPeopleMoveReason from 'Components/people/components/DrawerPeopleMoveReason';
import { SearchResultsRouteState } from 'Pages/search/GlobalSearchResults';
import SmallButton from './SmallButton';
import {
  primaryFont, wLight, primaryHeadingColor, wMLight, textBlack,
  maxWidth, retina, wMedium, maxTablet, maxMobile,
  minExtraLargeScreen,
  primaryColor,
  secondaryFont,
  extendedSearchLoader,
  minWidthApp,
  wMBold,
  maxWidth1300,
  searchLoaderList,
} from '../../../Utils/utilsStyle';
import PeopleListViewSkeleton from '../skeleton/PeopleListViewSkeleton';
import PeopleWidgetWithOutHolo from './PeopleWidgetWithOutHolo';

type Props = {
  heading?: string,
  peopleCollection?: Executive[],
  loading?: boolean,
  invertFollow?: boolean,
  peopleCount?: Executive[],
  count?: number,
  openInNewTab?: boolean,
  disableNavigation?: boolean,
  inGlobalSearch?: boolean,
  isRecommended?: boolean,
  query?: string,
  hideShowAll?: boolean,
  primarySearchLoaded?: boolean,
  extendedSearchLoaded?: boolean,
  isPaginationOverride?: boolean,
} & typeof defaultProps;

const defaultProps = {
  loading: false,
  peopleCollection: [] as Executive[],
  heading: '',
  invertFollow: false,
  peopleCount: [] as Executive[],
  count: 0,
  openInNewTab: false,
  disableNavigation: false,
  inGlobalSearch: false,
  isRecommended: false,
  query: '',
  hideShowAll: false,
};
const StyleWrapper = styled.div`
&.extendedSearch {
  margin-bottom: 16px;
  @media all and (min-width: ${minExtraLargeScreen}) {
    margin-bottom: 24px;
  }
}
.people-container{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0px;
  width: 100%;
  cursor: pointer;
  @media all and (min-width: ${minExtraLargeScreen}) {
    padding: 10px 0px;
  }
  @media all and (max-width: ${maxWidth}) , ${retina} {
    padding: 4px 0px;
  }
  @media all and (max-width: ${maxTablet}) {
    padding: 4px 0px;
  }
  @media all and (max-width: ${maxMobile}) {
    padding: 4px 0px;
  }
  &:hover {
    background: #FFF;
    border-radius: 6px;
  }
  .person-info{
    display: flex;
    column-gap: 10px;
    align-items: center;
    width:calc(100% - 84px);
    border: 2px solid transparent;
    @media all and (min-width: ${minExtraLargeScreen}) {
      column-gap: 14px;
      width: calc(100% - 120px);
    }
    @media all and (max-width: ${maxWidth}) , ${retina} {
      column-gap: 10px;
    }
    @media all and (max-width: ${maxTablet}) {
      column-gap: 6px;
    }
    @media all and (max-width: ${maxMobile}) {
      column-gap: 8px;
    }
    .personImg {
      width: 42px;
      @media all and (min-width: ${minExtraLargeScreen}) {
        width: 54px;
      }
      @media all and (max-width: ${maxWidth}) , ${retina} {
        width: 42px;
      }
      @media all and (max-width: ${maxTablet}) {
        width: 42px;
      }
      @media all and (max-width: ${maxMobile}) {
        width: 36px;
      }
      .person-without-holo {
        @media all and (max-width: ${minWidthApp}) {
          width: 42px;
          height: 42px;
          max-width: 42px;
        }
        @media all and (max-width: ${maxMobile}) {
          width: 36px;
          height: 36px;
          max-width: 36px;
        }
        @media all and (min-width: ${minExtraLargeScreen}) {
          width: 54px;
          height: 54px;
          max-width: 54px;
        }
      } 
    }
    .personName{
      width: calc(100% - 42px);
      cursor: pointer;
      @media all and (min-width: ${minExtraLargeScreen}) {
        width:calc(100% - 54px);
      }
      @media all and (max-width: ${maxWidth}) , ${retina} {
        width:calc(100% - 42px);
      }
      @media all and (max-width: ${maxTablet}) {
        width:calc(100% - 42px);
      }
      @media all and (max-width: ${maxMobile}) {
        width: calc(100% - 36px);
      }
      .person-designation-tip {
        @media all and (max-width: ${maxMobile}) {
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          word-wrap: break-word;
        }
      }
      .person-company-here {
        @media all and (max-width: ${maxWidth1300}) {
          display: inline-block;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
      .person-name-here{
        color: ${textBlack};
        font-family: ${primaryFont};
        font-size: 16px;
        font-weight: ${wMLight};
        line-height: 18px;
        letter-spacing: -0.52px;
        margin-top: 0px;
        margin-bottom: 6px;
        @media all and (min-width: ${minExtraLargeScreen}) {
          font-size: 22px;
          line-height: 23px;
          letter-spacing: -0.99px;
          margin-bottom: 8px;
        }
        @media all and (max-width: ${maxWidth}) , ${retina} {
          margin-top: 0px;
          font-size: 16px;
          line-height: 18px;
          letter-spacing: -0.52px;
          margin-bottom: 6px;
        }
        @media all and (max-width: ${maxTablet}) {
          font-size: 14px;
          line-height: 16px;
          letter-spacing: -0.336px;
          margin-bottom: 4px;
        }
        @media all and (max-width: ${maxMobile}) {
          font-size: 12px;
          line-height: 16px;
          letter-spacing: -0.396px;
          margin-bottom: 2px;
        }
      }
      .tagCompany {
        display: flex;
        column-gap: 6px;
        align-items: center;
        width: 100%;
        cursor: pointer;
        @media all and (min-width: ${minExtraLargeScreen}) {
          column-gap: 16px; 
        }
        @media all and (max-width: ${maxWidth}) , ${retina} {
          column-gap: 6px;
        }
        @media all and (max-width: ${maxTablet}) {
          column-gap: 4px;
        }
        @media all and (max-width: ${maxMobile}) {
          column-gap: 0px;
        }
        .person-tag-here {
          color: ${primaryHeadingColor};
          font-family: ${primaryFont};
          font-size: 14px;
          font-weight: ${wMedium};
          line-height: 16px;
          letter-spacing: -0.35px;
          max-width: calc(100% - 80px);
          display: inline-block;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          @media all and (min-width: ${minExtraLargeScreen}) {
            font-size: 20px;
            line-height: 21px;
            letter-spacing: -0.599px;
          }
          @media all and (max-width: ${maxWidth}) , ${retina} {
            font-size: 14px;
            line-height: 16px;
            letter-spacing: -0.35px;
          }
          @media all and (max-width: ${maxTablet}) {
            font-size: 12px;
            line-height: 14px;
            letter-spacing: -0.226px;
          }
          @media all and (max-width: ${maxMobile}) {
            font-size: 10px;
            line-height: 12px;
          }
          &.triggers-bullet-tooltip {
            &.person-designation-tip {
              .ant-tooltip {
                .ant-tooltip-content {
                  .ant-tooltip-inner {
                    white-space: normal;
                  }
                }
              }
            }
          }
        }
      }
      .person-company-here {
        margin-bottom: 0px;
        color: ${primaryHeadingColor};
        font-family: ${primaryFont};
        font-size: 14px;
        font-weight: ${wLight};
        line-height: 16px;
        letter-spacing: -0.35px;
        max-width: calc(100% - 80px);
        display: inline-block;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        position: relative;
        padding-left: 6px;
        &::before {
            content: "";
            min-height: 11px;
            min-width: 1px;
            background-color: rgb(207, 207, 207);
            position: absolute;
            left: 0px;
            top: 2px;
          }
        @media all and (min-width: ${minExtraLargeScreen}) { 
          font-size: 20px;
          line-height: 21px;
          letter-spacing: -0.599px;
          &::before {
            content: "";
            min-height: 15px;
            left: -9px;
            top: 0px;
          }
        }
        @media all and (max-width: ${maxWidth}) , ${retina} {
          font-size: 14px;
          line-height: 16px;
          letter-spacing: -0.35px;
          padding-left: 6px;
          &::before {
            min-height: 11px;
            left: 0px;
            top: 2px;
          }
        }
        @media all and (max-width: ${maxTablet}) {
          font-size: 12px;
          line-height: 14px;
          letter-spacing: -0.226px;
          padding-left: 5px;
          &::before {
            min-height: 8px;
            left: 0px;
            top: 3px;
          }
        }
        @media all and (max-width: ${maxMobile}) {
          font-size: 10px;
          line-height: 12px;
          padding-left:9px;
          &::before {
            min-height: 10px;
            left: 4px;
            top: 1px;
          }
        }
        .company-name-two {
          @media all and (max-width: ${maxTablet}) {
            font-size: 12px;
          }
        }
      }
      .drawer-icon {
        position: relative;
        .drawer-btn-action {
          &.drawerAction {
            left: 6px;
            top: -8px;
            @media all and (max-width: ${maxWidth}), ${retina} {
              top: -8px;
              left: 6px;
            }
            @media all and (max-width: ${minWidthApp}) {
              top:-8px;
            }
            @media all and (max-width: ${maxTablet}) {
              top: -6px;
              left: 6px;
            }
            @media all and (max-width: ${maxMobile}) {
              top: -7px;
              left: 12px;
            }
            .messageIcon {
              width: 20px;
              height: 20px;
              top: -3px;
              @media all and (max-width: ${maxWidth}), ${retina} {
                width: 16px;
                height: 16px;
                top: -1px;
              }
              @media all and (max-width: ${maxTablet}) {
                width: 14px;
                height: 14px;
              }
              @media all and (max-width: ${maxMobile}) {
                width: 18px;
                height: 18px;
                top: -2px;
                
              }
              svg {
                left: 4px;
                top:4px;
                @media all and (max-width: ${maxWidth}), ${retina} {
                  top: 4px;
                  left: 3px;
                  width: 10px;
                  height: 10px;
                }
                @media all and (max-width: ${maxTablet}) {
                  top: 3px;
                  left: 3px;
                  width: 8px;
                  height: 8px;
                }
                @media all and (max-width: ${maxMobile}) {
                  width: 11px;
                  height: 11px;
                  top: 4px;
                  left: 4px;
                }
              }
            }
          }
          &::before {
            content: "";
            min-height: 11px;
            min-width: 1px;
            background-color: rgb(207, 207, 207);
            position: absolute;
            left: -7px;
            top: 2px;
            @media all and (max-width: ${maxTablet}) {
              min-height: 8px;
            }
            @media all and (max-width: ${maxMobile}) {
              min-height: 10px;;
            }
          } 
        }
      }
    }
  }
  .follow-c-btn {
    .small-button-chinese {
      display: inline-flex;
      height: 24px;
      width: 84px;
      padding: 4px 14px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 16px;
      text-align: center;
      font-family: ${primaryFont};
      font-size: 14px;
      font-weight: ${wMLight};
      line-height: 17px;
      @media all and (min-width: ${minExtraLargeScreen}) {
        height: 34px;
        width: 120px;
        font-size: 20px;
        line-height: 23px;
        border-radius: 22px;
      }
      @media all and (max-width: ${maxWidth}) , ${retina} {
        height: 24px;
        width: 84px;
        border-radius: 16px;
        font-size: 14px;
        line-height: 17px;
        padding: 4px 14px;
      }
      @media all and (max-width: ${maxTablet}) {
        height: 20px;
        width: 72px;
        padding: 3px 12px;
        border-radius: 16px;
        font-size: 12px;
        line-height: 15px;
      }
      @media all and (max-width: ${maxMobile}) {
        height: 20px;
        width: 64px;
        font-size: 12px;
        line-height: 15px;
        padding: 3px 12px;
      }
    }
  }
  &:last-child {
    margin-bottom: 0px;
  }
}
`;

const LoaderWrapper = styled.div`
  width: 100%;
  .main {
    background:white;
    border:1px solid ${primaryColor};
    text-align: center;
    border-radius: 10px;
    display: flex;
    align-items: center;
    width: 100%;
    height:42px;
    margin: 0px;
    .loader-style{
      height: 70px;
      margin-left: -10px;
    }
    .text{
      font-size: 16px;
      color:${primaryHeadingColor};
      font-weight: ${wMBold};
      font-family: ${secondaryFont};
      letter-spacing: -0.45px;
      line-height: 14px;
      margin-bottom: 0px;
    }
  }
`;

const PeopleSectionListView = function PeopleSectionListView(props: Props) {
  const [searchParams] = useSearchParams();
  const { pathname, search } = useLocation();
  const extendedSections = ['person', 'company', 'article'];
  const extendedSection = (searchParams.get('extend') ?? '');
  const isDetailedSearch: boolean = extendedSections.includes(extendedSection);
  const isPagination: boolean = useSelector(selectIsPagination);
  const isOnboarding = isOnboardingRoute();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const host = window.location.href;
  const startTime = getCurrentTime();
  const followFailed = useSelector(selectFollowFailed);
  const followLoading = useSelector(selectFollowLoading);
  const data = useSelector(selectData);
  const isSearchPage = pathname.includes(SEARCH);
  const [followButtonPersonId, setFollowButtonPersonId] = useState(0);
  const globalSearchLoaded = useSelector(selectSearchLoaded);
  const personsLoaded = useSelector(selectPersonLoaded);
  const {
    heading,
    peopleCollection,
    loading,
    invertFollow,
    peopleCount,
    count,
    openInNewTab,
    disableNavigation,
    inGlobalSearch,
    isRecommended,
    query,
    hideShowAll,
    primarySearchLoaded,
    extendedSearchLoaded,
    isPaginationOverride,
  } = props;
  const primaryLoaded = typeof primarySearchLoaded === 'boolean'
    ? primarySearchLoaded
    : globalSearchLoaded;
  const extendedLoaded = typeof extendedSearchLoaded === 'boolean'
    ? extendedSearchLoaded
    : personsLoaded;
  const paginationActive = typeof isPaginationOverride === 'boolean'
    ? isPaginationOverride
    : isPagination;
  const shouldShowPaginationSkeleton = paginationActive
    && (isDetailedSearch || typeof isPaginationOverride === 'boolean');
  const formattedCount = formatNumberWithCommas(count);
  const location = useLocation();
  const { state } = location as { state: SearchResultsRouteState };
  const previousPath = (state)?.previousPath ?? FEED_GILROY_ROUTE;

  useEffect(() => {
    setFollowButtonPersonId(0);
  }, [followFailed]);

  useEffect(() => {
    if (!followLoading) {
      setFollowButtonPersonId(0);
    }
  }, [followLoading]);

  const createPeopleRoute = () => {
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('searchPage_people_see_all_clicked', 0, {
        host,
      }),
    ));
    window.scrollTo(0, 0);
    let path = `${pathname}?query=${query}&extend=person`;
    const groupId = searchParams.get('groupId');
    if (search.includes('groupId') && groupId && parseInt(groupId, 10) > 0) {
      path = `${path}&groupId=${groupId}`;
    }
    return navigate(path, { state: { enableBackButton: true, previousPath } });
  };

  const handleFollowPerson = (person: Executive) => {
    if (!person?.personAdded) {
      setFollowButtonPersonId(person?.personId);
      const obj: UpdatePersonProfileFollow = {
        person_data: person?.personType && person?.personName && person?.personId ? [{
          type: person.personType,
          query: person.personName,
          entity_id: person.personId,
        }] : undefined,
      };
      const groupId = searchParams.get('groupId');
      if (pathname.includes(SEARCH) && groupId && parseInt(groupId, 10) > 0) {
        obj.group_id = parseInt(groupId, 10);
      }
      dispatch(peopleFollowActions.updateProfileFollow(obj));
      if (obj.person_data && obj.person_data.length > 0) {
        if (isOnboarding) {
          dispatch(flurryActions.callFlurryEvent(
            valueToObject('click_Follow_FollowPeople_Onboarding', startTime, {
              person_data: obj.person_data,
              host,
            }),
          ));
        }
      }
    } else {
      setFollowButtonPersonId(person?.personId);
      const obj: UpdatePersonProfileFollow = {
        feedids: [person?.personId],
        type: person?.personType,
      };
      dispatch(peopleFollowActions.updateProfileFollow(obj));
      if (isOnboarding) {
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('click_Unfollow_FollowPeople_Onboarding ', startTime, {
            feedids: obj.feedids,
            type: obj.type,
            host,
          }),
        ));
      }
    }
  };

  const handleClick = (person: Executive) => {
    setFollowButtonPersonId(person?.personId);
    handleFollowPerson(person);
    const follow = invertFollow ? !person.personAdded : person.personAdded;
    if (follow && !pathname.includes('onboarding')) {
      dispatch(certificationActions.certificationAction({
        type: 'person_follow',
        source: 'search',
        data,
      }));
    }
    if (isSearchPage) {
      if (follow) {
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('searchPage_person_follow_clicked', 0, {
            person_name: person?.personName,
            person_id: person?.personId,
            type: person?.personType === 'LIVESEARCH' ? 'LIVESEARCH' : 'EXECUTIVE',
            host,
          }),
        ));
      } else {
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('searchPage_person_unfollow_clicked', 0, {
            person_name: person?.personName,
            person_id: person?.personId,
            type: person?.personType === 'LIVESEARCH' ? 'LIVESEARCH' : 'EXECUTIVE',
            host,

          }),
        ));
      }
    }
    if (isRecommended) {
      if (follow) {
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('peopleDashboard_recommended_follow_person', 0, {
            person_id: person?.personId,
            host,
          }),
        ));
      }
    }
  };

  const navigateToSearchResult = () => {
    const path = `${SEARCH_ROUTE}${query}`;
    navigate(path, {
      state: isDetailedSearch ? { enableBackButton: true, previousPath } : { previousPath },
    });
  };

  const handleInfoClick = (person: Executive) => {
    if (person?.personId && person?.personType) {
      const url = `${PERSONALITY_INSIGHTS_ROUTE}${person?.personId}&personType=${person?.personType}`;
      navigate(url);
    }
  };

  const handlePersonClick = ({ personId, personName, personType }: Executive) => {
    dispatch(certificationActions.setSearchPersonClicked(true));
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('searchPage_person_clicked', 0, {
        person_id: personId,
        person_name: personName,
        type: personType,
        host,
      }),
    ));
  }

  return (
    (
      peopleCollection.length > 0 || loading ? (
        <StyleWrapper
          className={classNames({
            extendedSearch: isDetailedSearch,
          })}
        >
          {
            loading ? (
              <PeopleListViewSkeleton />
            ) : (
              <div>
                <HeadingWithShowAll
                  inGlobalSearch={inGlobalSearch}
                  isShowAllHidden={hideShowAll || (isDetailedSearch ? true
                    : peopleCount && peopleCount.length <= 4)}
                  leftHeading={(
                    <SectionHeading customClassName="global-search-heading">{`${heading} (${formattedCount})`}</SectionHeading>)}
                  onClick={createPeopleRoute}
                  onSeelessClick={navigateToSearchResult}
                  isDetailedSearch={!hideShowAll && isDetailedSearch}
                />
                {peopleCollection?.map((person: Executive) => (
                  <div
                    className="people-container"
                    key={person.personId}
                    onClick={() => handleInfoClick(person)}
                    onKeyDown={() => handleInfoClick(person)}
                    tabIndex={0}
                    role="button"
                  >
                    <div className="person-info"
                      onClick={() => handlePersonClick(person)}
                    >
                      <div className="personImg">
                        <PeopleWidgetWithOutHolo
                          logo={person.personImage}
                          persona={person.archeType.color}
                          hidePersonality
                          personality={person.archeType.name}
                          wrapperColor={backgroundColorParsing(person.personalityTypes)}
                          showRemoveIcon={false}
                          showCheckBox={false}
                          checked={false}
                          personId={person.personId}
                          diameter="42px"
                          diameterXsm="26px"
                          diameterSm="42px"
                          ringPadding="2px"
                          ringPaddingSm="2px"
                          marginSm="0px"
                          margin="0px"
                          type={person?.personType}
                          openInNewTab={openInNewTab}
                          disableNavigation={disableNavigation}
                          inGlobalSearch={inGlobalSearch}
                        />
                      </div>
                      <div className="personName">
                        <span
                          role="button"
                          tabIndex={0}
                          aria-label={`view ${person.personName} profile`}
                        >
                          <div className="d-flex">
                            <Tooltip
                              trigger="hover"
                              placement="top"
                              getPopupContainer={(e: HTMLElement) => e}
                              className="triggers-bullet-tooltip person-designation-tip"
                              color="#fff"
                              title={person.personName}
                              arrow={false}
                            >
                              <span
                                className="person-name-here"
                                onClick={() => handleInfoClick(person)}
                                onKeyDown={() => handleInfoClick(person)}
                                tabIndex={0}
                                role="button"
                              >
                                {person?.personName}
                              </span>
                            </Tooltip>
                          </div>

                          <div className="tagCompany">
                            <Tooltip
                              arrow={false}
                              trigger="hover"
                              placement="topLeft"
                              getPopupContainer={(e: HTMLElement) => e}
                              className="triggers-bullet-tooltip person-designation-tip"
                              color="#fff"
                              title={person.companyId === 1880420 ? (person.location?.length ? person.location : person?.companyName) : person?.personDesignation
                                ? person?.personDesignation : person?.headline}
                            >
                              <span
                                className="mb-0 person-tag-here"
                                onClick={() => handleInfoClick(person)}
                                onKeyDown={() => handleInfoClick(person)}
                                tabIndex={0}
                                role="button"
                              >
                                {person.companyId === 1880420 ? (person.location?.length ? person.location : person?.companyName) : person?.personDesignation
                                  ? person?.personDesignation : person?.headline}
                              </span>
                            </Tooltip>
                            <Tooltip
                              arrow={false}
                              trigger="hover"
                              placement="top"
                              getPopupContainer={() => document.querySelector('.triggers-bullet-tooltip') as HTMLElement}
                              // getPopupContainer={(e: HTMLElement) => e}
                              className="triggers-bullet-tooltip person-designation-tip"
                              color="#fff"
                              title={person.companyId === 1880420 ? '' : person?.companyName}
                            >
                              <span
                                className="company-name-two person-company-here"
                                role="button"
                                tabIndex={0}
                                onClick={() => handleInfoClick(person)}
                                onKeyPress={() => handleInfoClick(person)}
                              >
                                {person.companyId === 1880420 ? '' : person?.companyName}
                              </span>
                            </Tooltip>
                            {
                              person?.personNotes ? (
                                <div
                                  className="drawer-icon"
                                  role="button"
                                  tabIndex={0}
                                  aria-label="button"
                                  onClick={(e) => e.stopPropagation()}
                                  onKeyPress={(e) => e.stopPropagation()}
                                >
                                  <DrawerPeopleMoveReason
                                    personId={person.personId}
                                    showNotes
                                    isPersonCard
                                  />
                                </div>
                              ) : (null)
                            }
                          </div>
                        </span>
                      </div>
                    </div>
                    <div
                      className="d-flex justify-content-center follow-c-btn"
                      role="button"
                      tabIndex={0}
                      aria-label="button"
                      onClick={(e) => e.stopPropagation()}
                      onKeyPress={(e) => e.stopPropagation()}
                    >
                      <SmallButton
                        title={invertFollow ? (!person.personAdded ? 'Follow' : 'Unfollow') : (person.personAdded ? 'Unfollow' : 'Follow')}
                        variant={invertFollow ? (!person.personAdded ? 'filled' : 'outlined') : (person.personAdded ? 'filled' : 'outlined')}
                        color="#001760"
                        padding={invertFollow ? (!person.personAdded ? '3px 11px' : '3px 5px') : (person.personAdded ? '3px 5px' : '3px 11px')}
                        disabled={followButtonPersonId === person?.personId}
                        onButtonClick={() => handleClick(person)}
                      />
                    </div>
                  </div>
                ))}

                {(primaryLoaded
                  && !extendedLoaded
                  && peopleCollection.length > 0) && (
                    <LoaderWrapper className="loader-wrapper">
                      <div className="main">
                        <img className="loader-style" src={searchLoaderList} alt="extended-loader" />
                      </div>
                    </LoaderWrapper>
                  )}

                {shouldShowPaginationSkeleton && <PeopleListViewSkeleton />}
              </div>
            )
          }
        </StyleWrapper>
      ) : (
        (primaryLoaded
          && !extendedLoaded
          && peopleCollection.length === 0)
          ? (
            <LoaderWrapper className="loader-wrapper">
              <div className="main">
                <img className="loader-style" src={searchLoaderList} alt="extended-loader" />
              </div>
            </LoaderWrapper>
          ) : null
      )
    )

  );
};
PeopleSectionListView.defaultProps = defaultProps;
export default PeopleSectionListView;